import { getCookie } from "../../services/utility.service"
import getOneLinkBaseUrl from "./get-onelink-base-url"
import hideAppBlock from "./hide-app-block"

const oneLinkSmartScript = options => {
  try {
    if (
      options
    ) {
      if (
        options.url
      ) {
        return {
          src: options.url,
          beforeLoad: !!options.beforeLoad,
          defer: !!options.defer,
          async: !!options.async,
          onDCL: !!options.onDCL,
          'onload': () => {
            let ampUTMParamFound = false
            const checkMediaCampaign = () => {
              let urlParam = new URLSearchParams(window.location.search)
              if(urlParam.size > 0) {
                return {
                  mediaSourceSet: !!(urlParam.get('cust_src') || urlParam.get('utm_source') || urlParam.get('pid')),
                  campaignIdSet: !!(urlParam.get('utm_campaign') || urlParam.get('can') || urlParam.get('c')),
                  custSrcVal: urlParam.get('cust_src')
                }
              }
              return {mediaSourceSet: false, campaignIdSet: false, custSrcVal: ''}
            }
            const logFallbackMethod = (utmParams) => {
              if(utmParams) ampUTMParamFound = true
              if(!utmParams) {
                console.log(`Tracking parameter could not be stored. Fallback methods failed.`)
              }
            }
            const onelinkReplicateFn = () => {
              const utmParams = JSON.parse(window.sessionStorage.getItem(`ampUTMParam`))
              if(ampUTMParamFound) return
              logFallbackMethod(utmParams)
              const {mediaSourceSet, campaignIdSet, custSrcVal} = checkMediaCampaign()

              const mediaSource = {keys: mediaSourceSet ? ["pid", "utm_source","cust_src"] : [""], defaultValue: utmParams && utmParams['utm_source'] ? utmParams['utm_source'] : 'web-bookmark-or-typed'}
              const utmCampaign = utmParams && utmParams['utm_campaign']
              const campaign = {keys: campaignIdSet ? ["c", "utm_campaign", "can"] : [""], defaultValue: utmCampaign ? utmParams['utm_campaign'] : 'organic'}
              const afSub1 = {keys: ["cuid"]}
              const afSub2 = {keys: ["jid"]}
              const afSub3 = {keys: ["utm_medium"]}
              const afParameters = {mediaSource, ...(utmCampaign && {campaign}),afSub1, afSub2, afSub3}
              let oneLinkTemplateIdProd = ''
              let appsInfo = window.pageData.dataCountryThemeSetting?.nodes[0].countryThemeSettings
              if(appsInfo) {
                oneLinkTemplateIdProd = appsInfo.oneLinkTemplateIdProd
              }
              if(window.pageData.getAllAppflyerInfo) {
                let getAllAppflyerInfo = JSON.parse(window.pageData.getAllAppflyerInfo)
                let countryCookie = getCookie('AKCountry') || getCookie('WUCountryCookie_')
                appsInfo = getAllAppflyerInfo.filter((x) => x.slug.toUpperCase() === countryCookie.toUpperCase())[0]
                if(!appsInfo) {
                  appsInfo = getAllAppflyerInfo.filter((x) => x.slug.toUpperCase() === "US")[0]
                }
                if(appsInfo) {
                  oneLinkTemplateIdProd = appsInfo.oneLinkTemplateIdProd
                }
              }
              if(!oneLinkTemplateIdProd) return
              const oneLinkURL = `${getOneLinkBaseUrl()}${oneLinkTemplateIdProd}`
              hideAppBlock()
              const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
                oneLinkURL,
                afParameters
              })
              if (result) {
                if(custSrcVal) {
                  let url = new URL(result.clickURL)
                  url.searchParams.set('pid', custSrcVal)
                  result.clickURL = url.toString()
                }
                let result_url = result.clickURL
                const qrCodeElements = document.querySelectorAll(".onelink_qrcode")
                const appCodeElements = document.querySelectorAll(".onelink_appstore, [href^='https://smart.link'], [href^='http://smart.link'], [href^='http://westernunion.onelink']")
                Array.from(qrCodeElements).forEach((qrCodeElement, index) => {
                  const qrImage = qrCodeElement.querySelector('img')
                  const canvasEls = qrCodeElement.querySelectorAll('canvas')
                  if (canvasEls.length > 0) {
                    canvasEls.forEach((canvasEl) => {
                      canvasEl.remove()
                    })
                  }
                  if(qrImage) {
                    qrImage.classList.add("d-none")
                    qrImage.classList.remove('d-block')
                  }
                  qrCodeElement.id = `onelink-qrcode-${index}`
                  window.AF_SMART_SCRIPT.displayQrCode(qrCodeElement.id)
                  let canvas = qrCodeElement.querySelector('canvas')
                  if(canvas) {
                    canvas.classList.add('w-100')
                    canvas.setAttribute('style', "border: 5px solid white;")
                  }
                })
                Array.from(appCodeElements).forEach((el) => {
                  el.href =  result_url
                })
              }
            }
            onelinkReplicateFn()
            !ampUTMParamFound && setTimeout(onelinkReplicateFn, 2000)
            !ampUTMParamFound && setTimeout(onelinkReplicateFn, 2000)
          }
        }
      }

      return
    }

    console.log(`Please verify the oneLinkSmartScript url: ${options.url}`)
  } catch (e) {
    console.log(`There is an error. oneLinkSmartScript cannot be loaded.`)
  }
}

export default oneLinkSmartScript